import { Link } from 'react-router-dom'

const ErrorPage = () => {
  return (
    <div className="container d-flex flex-column justify-content-center align-items-center text-center vh-100">
      <div className="mb-3">
        <h1 className="display-1 fw-bold text-primary">404</h1>
        <h4 className="text-muted">Página no encontrada</h4>
      </div>

      <p className="lead mb-4">La página que buscas no existe o fue movida.</p>

      <Link to="/" className="btn btn-primary btn-lg px-4">
        Volver al inicio
      </Link>
    </div>
  )
}

export default ErrorPage
